<template>
  <div
    @drop="dropPhoto"
    @dragover="allowDrop"
    @click="clickPaper"
    align="left"
    :style="dispWinStyle"
  >
    <img v-if="itemType === 'photo'" :src="imgCachedURL" :style="imageStyle" alt="" />
    <v-touch
      @swiperight="onSwipeRight"
      @pinchout="pinchOut"
      @pinchin="pinchIn"
      @pinchend="pinchEnd"
      @panstart="panStart"
      @panmove="panMove"
      @panend="panEnd"
      tag="div"
    >
      <canvas
        v-if="itemType === 'photo'"
        @wheel="mouseWheel"
        ref="canvas"
        :id="canvasid"
        :style="canvasStyle"
      />
    </v-touch>
    <el-input
      :autofocus="true"
      v-if="showTxtInput"
      :style="txtGraphStyle"
      v-model="txtGraph"
      class="input-with-select"
    >
      <el-button type="info" @click="txtBtnOK" slot="append">{{ $t("langcfg.txtOK") }}</el-button>
    </el-input>
  </div>
</template>

<script>
import paper from "paper";
import GraphProc from "../js/graphics";
import { isDefined } from "../../shared/utils";
import { IMAGESIZE } from "../../shared/consts";
import { isDataValid } from "../../topography/shared";
const layerwidth = window.innerWidth;
const layerheight = window.innerHeight;
let isDragging = false;
function paperInit(canvasid, loadImg, _self, marking, osd) {
  for (let i in paper.projects) {
    if (paper.projects[i].view) {
      if (paper.projects[i].view.element.id === canvasid) {
        paper.projects[i].remove();
      }
    }
  }
  if (!_self.$refs.canvas) return;
  if (_self.graphMode !== "Text") {
    _self.showTxtInput = false;
    _self.txtGraph = "";
  }
  paper.setup(canvasid);
  let m = new paper.Matrix(1, 0, 0, 1, 0, 0);
  if (!loadImg) return;
  let whratioImg = loadImg.width / loadImg.height;
  let whratioDisp = _self.imgW / _self.imgH;
  let vscale =
    whratioDisp > whratioImg
      ? _self.imgH / (loadImg.width / whratioImg)
      : _self.imgW / loadImg.width;
  let viewWidth = whratioDisp > whratioImg ? _self.imgH * whratioImg : _self.imgW;
  let viewHeight = whratioDisp > whratioImg ? _self.imgH : _self.imgW / whratioImg;
  let drawScale =
    loadImg.width / IMAGESIZE.width < loadImg.height / IMAGESIZE.height
      ? loadImg.height / IMAGESIZE.height
      : loadImg.width / IMAGESIZE.width;
  m = m.scale(vscale, new paper.Point(0, 0));
  _self.viewScale = vscale;
  paper.view.setViewSize(viewWidth, viewHeight);
  paper.view.matrix = m;
  if (loadImg.width < 10) return;
  let graph = new GraphProc(paper, window.magecoe[_self.curPage], self.edges, true);
  graph.drawScale = drawScale.toFixed(2);
  graph.strokeWidth = 4 * drawScale;
  graph.fontSize = 48 * drawScale;
  graph.offset = 100 * drawScale;
  if (graph.strokeWidth < 0.1) graph.strokeWidth = 0.1;
  // debugger
  graph.on("update", function (content, segments, curTearHeight, delAuto) {
    _self.imgMarking = content;
    if (_self.curPage === "pupilcorneadia") {
      _self.imgMarking = "";
    }
    _self.$emit("update", content, segments, curTearHeight, delAuto);
  });
  // 其他病例不响应图片修改
  paper.view.onMouseMove = (event) => {
    graph.mouseMove(event, _self.graphMode);
  };
  paper.view.onMouseUp = (event) => {
    graph.mouseUp(event, _self.graphMode);
    if (event.event.button === 2) {
      _self.$emit("rightClick", 0);
    }
  };
  paper.view.onMouseDown = (event) => {
    paper._testid = canvasid;
    _self.$emit("focus", 0, paper);
    graph.mouseDown(event, _self.graphMode, _self.graphColor, _self.currentUnit);
    let obj = graph.calcTearHeightAvg(_self.mytearheight);
    if (_self.graphMode === "Height" && obj.contents_array.length >= 20) {
      _self.$bus.$emit("errorText", _self.$t("langcfg.txtExceededTheAnnotationLimit"));
    }
    if (_self.graphMode === "AutoHeight" && obj.contents_array.length < 20) {
      if (_self.mytearheight && _self.mytearheight.tearArrayX && loadImg) {
        let arrX = _self.mytearheight.tearArrayX;
        let pointX = Number(event.point.x.toFixed());
        let index = arrX.indexOf(pointX);
        if (index >= 0) {
          let scale = IMAGESIZE.width / loadImg.width;
          let event = {};
          event.pointup = {};
          event.pointdown = {};
          event.pointup.x = _self.mytearheight.upArrayX[index];
          event.pointup.y = _self.mytearheight.upArrayY[index];
          event.pointdown.x = _self.mytearheight.downArrayX[index];
          event.pointdown.y = _self.mytearheight.downArrayY[index];
          graph.drawHeight(
            event,
            _self.graphMode,
            _self.height,
            _self.graphColor,
            _self.currentUnit,
            scale
          );
          _self.myHeight = {};
        } else {
          if (_self.mytearheight.tearArrayX.length < 1) {
            _self.$bus.$emit("errorText", _self.$t("langcfg.txtAutomaticDrawingFailed"));
          } else {
            _self.$bus.$emit("errorText", _self.$t("langcfg.txtBeyondTheScopeOfTheTearRiverArea"));
          }
        }
      }
    } else if (_self.graphMode === "AutoHeight" && obj.contents_array.length >= 20) {
      _self.$bus.$emit("errorText", _self.$t("langcfg.txtExceededTheAnnotationLimit"));
    }
  };
  paper.view.onMouseDrag = (event) => {
    graph.mouseDrag(event, _self.graphMode);
  };
  paper.view.onDoubleClick = (event) => {
    graph.DoubleClick(event, _self.graphMode);
  };
  paper.view.onKeyDown = (event) => {
    if (event.key === "shift") {
      graph.isShiftDown = true;
    }
  };
  paper.view.onKeyUp = (event) => {
    if (event.key === "shift") {
      graph.isShiftDown = false;
    }
  };

  if (
    _self.tearHeight &&
    loadImg &&
    _self.mytearheight.trensdDataYHeigth &&
    _self.mytearheight.autocalcPoint
  ) {
    let scale = IMAGESIZE.width / loadImg.width;
    let event = {};
    event.pointup = {};
    event.pointdown = {};
    event.pointup.x = _self.tearHeight.upX;
    event.pointup.y = _self.tearHeight.upY;
    event.pointdown.x = _self.tearHeight.downX;
    event.pointdown.y = _self.tearHeight.downY;
    graph.drawHeight(
      event,
      _self.graphMode,
      _self.height,
      _self.graphColor,
      _self.currentUnit,
      scale
    );
    _self.myHeight = {};
  }
  graph.on("edge-changed", (mode, edge) => {
    _self.pupilCorneaChanged(mode, edge);
  });
  graph.on("drag", (state) => {
    isDragging = state;
  });
  if (
    isDefined(_self.edges) &&
    isDefined(loadImg) &&
    isDataValid(_self.edges.corneadia.r) &&
    isDataValid(_self.edges.pupildia.r)
  ) {
    graph.drawPupilEdge(_self.edges.pupildia);
    graph.drawCorneaEdge(_self.edges.corneadia);
  }
  graph.on("updatetext", function (point, origtxt, callback) {
    _self.txtGraphStyle.left = `${_self.viewScale * point.x + _self.dispMarginLeft - 20}px`;
    _self.txtGraphStyle.top = `${_self.viewScale * point.y + _self.dispMarginTop - 20}px`;
    _self.txtGraph = origtxt;
    _self.inputCallback = callback;
    _self.showTxtInput = true;
  });
  graph.on("waitinput", function (point, callback) {
    _self.txtGraphStyle.left = `${_self.viewScale * point.x + _self.dispMarginLeft - 20}px`;
    _self.txtGraphStyle.top = `${_self.viewScale * point.y + _self.dispMarginTop - 20}px`;
    _self.inputCallback = callback;
    _self.showTxtInput = true;
  });

  paper.view.draw();
  if (marking) {
    graph.importMarking(marking);
  }
  if (osd && osd.length > 1) {
    graph.drawTextOSD(osd);
  }
  _self.selectPaper(graph);
}

export default {
  name: "ImageBox",
  mounted() {
    let _self = this;
    let loadImg = new Image();
    loadImg.onload = function () {
      _self.imgCachedURL = loadImg.src;
      _self.image = loadImg;
      paperInit(_self.canvasid, loadImg, _self, _self.marking, _self.eyetype);
      _self.imgMarking = _self.marking;
      _self.imgSizeWidth = loadImg.width;
      _self.imgSizeHeight = loadImg.height;
    };
    if (_self.itemType === "photo") {
      _self.$emit("loading");
      loadImg.src = this.src;
    }
    _self.originImgLeft = _self.dispMarginLeft;
    _self.originImgTop = _self.dispMarginTop;
  },
  props: {
    currentUnit: String,
    value: String,
    colorHex: String,
    width: { type: Number, default: 320 },
    height: { type: Number, default: 240 },
    background: { type: String, default: "#222" },
    src: String,
    focus: Boolean,
    marking: String,
    eyetype: String,
    proc: String,
    curPage: String,
    tearHeight: Object,
    mytearheight: Object,
    graphMode: String,
    edges: {
      type: Object,
      default: () => {
        return {
          pupildia: {
            x: -1000,
            y: -1000,
            r: -1000
          },
          corneadia: {
            x: -1000,
            y: -1000,
            r: -1000
          }
        };
      }
    }
  },
  components: {},
  data() {
    return {
      stageSize: {
        width: layerwidth,
        height: layerheight
      },
      configCircle: {
        x: 500,
        y: 500,
        radius: 50,
        fill: "red",
        draggable: true
      },
      txtGraphStyle: {
        position: "absolute",
        width: "200px",
        left: "0px",
        top: "0px"
      },
      txtGraph: "",
      showTxtInput: false,
      inputCallback: undefined,
      imgCachedURL: "",
      image: undefined,
      viewScale: 1.0,
      zoom: 1.0,
      imgMarking: "",
      leftOffset: 0,
      topOffset: 0,
      myHeight: this.tearHeight,
      curZoom: 1.0,
      isMouseDown: false,
      pinchVal: {
        deltaX: 0,
        deltaY: 0,
        center: { x: 0, y: 0 },
        curScale: 0,
        pinchMode: "",
        srcEventClientX: 0,
        srcEventClientY: 0
      },
      originImgLeft: 0,
      originImgTop: 0,
      imgSizeWidth: 0,
      imgSizeHeight: 0,
      curdeltaX: 0,
      curdeltaY: 0
    };
  },
  watch: {
    edges: {
      deep: true,
      handler: function () {
        paperInit(this.canvasid, this.image, this, undefined, this.eyetype);
      }
    },
    src: function (val, oldval) {
      let loadImg = new Image();
      let _self = this;
      loadImg.onload = function () {
        _self.imgCachedURL = loadImg.src;
        _self.image = loadImg;
        paperInit(_self.canvasid, loadImg, _self, _self.marking, _self.eyetype);
        _self.$emit("init-drawtype", "Select");
        _self.imgMarking = _self.marking;
        _self.initZoom();
        _self.imgSizeWidth = loadImg.width;
        _self.imgSizeHeight = loadImg.height;
      };
      if (_self.itemType === "photo") {
        _self.$emit("loading");
        loadImg.src = val;
        _self.imgCachedURL = loadImg.src;
      }
    },
    tearHeight(newVal, oldVal) {
      this.tearHeight = newVal;
    },
    autocalcvalue(newVal) {
      this.autocalcvalue = newVal;
    },
    marking: {
      handler(curVal) {
        this.imgMarking = curVal;
        paperInit(this.canvasid, this.image, this, this.imgMarking, this.eyetype);
      },
      immediate: true,
      deep: true
    },
    width() {
      this.initZoom();
      if (this.width && this.image) {
        paperInit(this.canvasid, this.image, this, this.imgMarking, this.eyetype);
      }
    },
    height() {
      this.initZoom();
      if (this.height && this.image) {
        paperInit(this.canvasid, this.image, this, this.imgMarking, this.eyetype);
      }
    },
    zoom(newValue) {
      if (this.zoom && this.image) {
        paperInit(this.canvasid, this.image, this, this.imgMarking, this.eyetype);
      }
    }
  },
  computed: {
    canvasid() {
      return "imgCanvas";
    },
    itemType() {
      return "photo";
    },
    dispWinStyle() {
      let style = {
        position: "relative",
        width: `${this.width}px`,
        height: `${this.height}px`,
        background: "#222",
        border: "0px",
        overflow: "hidden"
      };
      return style;
    },
    imgW() {
      return this.width * this.zoom;
    },
    imgH() {
      return this.height * this.zoom;
    },
    imgWHRatio() {
      return this.image ? this.image.width / this.image.height : 4 / 3;
    },
    dispW() {
      return this.imgW / this.imgH > this.imgWHRatio
        ? Math.floor(this.imgH * this.imgWHRatio)
        : this.imgW;
    },
    dispH() {
      return this.imgW / this.imgH > this.imgWHRatio
        ? this.imgH
        : Math.floor(this.imgW / this.imgWHRatio);
    },
    originMarginLeft() {
      return (this.width - this.dispW / this.zoom) / 2;
    },
    originMarginTop() {
      return (this.height - this.dispH / this.zoom) / 2;
    },
    dispMarginTop() {
      return this.topOffset + this.originMarginTop;
    },
    dispMarginLeft() {
      return this.leftOffset + this.originMarginLeft;
    },
    canvasStyle() {
      let style = {};
      style.width = `${this.dispW}px`;
      style.height = `${this.dispH}px`;
      style.marginTop = `${this.dispMarginTop}px`;
      style.marginLeft = `${this.dispMarginLeft}px`;
      style.position = "absolute";
      return style;
    },
    imageStyle() {
      let style = {};
      style.width = `${this.dispW}px`;
      style.height = `${this.dispH}px`;
      style.marginTop = `${this.dispMarginTop}px`;
      style.marginLeft = `${this.dispMarginLeft}px`;
      style.left = "0px";
      style.top = "0px";
      style.position = "absolute";
      style.background = this.background;
      style.filter = this.proc;
      style.border = "none";
      return style;
    },
    graphColor() {
      let r = parseInt(this.colorHex.substr(1, 2), 16) / 255.0;
      let g = parseInt(this.colorHex.substr(3, 2), 16) / 255.0;
      let b = parseInt(this.colorHex.substr(5, 2), 16) / 255.0;
      return new paper.Color(r, g, b, 1.0);
    }
  },
  methods: {
    getPaperView(e) {
      return e;
    },
    handleMouseMove(event) {
      // const mousePos = this.$refs.stage.getNode().getPointerPosition();
      // const x = mousePos.x - 190;
      // const y = mousePos.y - 40;
      // this.writeMessage('x: ' + x + ', y: ' + y);
    },
    handleMouseUp(event) {},
    handleDragStart() {
      this.isDragging = true;
    },
    videoTimeUpdate() {
      this.$emit("videoTimeUpdate");
    },
    pupilCorneaChanged(mode, edge) {
      this.$emit("edge-changed", mode, edge);
    },
    allowDrop(ev) {
      ev.preventDefault();
    },
    dropPhoto(ev) {
      ev.preventDefault();
      let photoID = ev.dataTransfer.getData("Photo");
      this.$emit("dropPhoto", 0, parseInt(photoID));
    },
    initZoom() {
      // if (this.curPage === 'tearheight') {
      //   this.zoom = 2.0
      //   this.curZoom = 2.0
      //   this.leftOffset = -500
      //   this.topOffset = -800
      // } else {
      //   // 非tearHeight模块无需位移放大
      //   this.zoom = 1.0
      //   this.curZoom = 1.0
      //   this.leftOffset = 0
      //   this.topOffset = 0
      // }
      this.zoom = 1.0;
      this.curZoom = 1.0;
      this.leftOffset = 0;
      this.topOffset = 0;
    },
    txtBtnOK() {
      this.inputCallback(this.txtGraph);
      this.showTxtInput = false;
      this.txtGraph = "";
    },
    panStart(event) {},
    panEnd(event) {
      this.curdeltaX = 0;
      this.curdeltaY = 0;
    },
    panMove(event) {
      if (isDragging) return;
      // debugger
      if (this.zoom > 1 && (this.graphMode === "Eraser" || this.graphMode === "Select")) {
        let moveX = 0;
        let moveY = 0;
        if (this.curdeltaX === 0) {
          moveX = 1;
          this.curdeltaX = event.center.x;
        } else {
          moveX = Math.abs(event.center.x - this.curdeltaX);
        }
        if (this.curdeltaY === 0) {
          moveY = 1;
          this.curdeltaY = event.center.y;
        } else {
          moveY = Math.abs(event.center.y - this.curdeltaY);
        }
        let left = this.leftOffset + moveX;
        let top = this.topOffset + moveY;
        if (event.center.x - this.curdeltaX > 0 && left < -this.originImgLeft) {
          this.leftOffset += moveX;
        } else {
        }
        if (
          event.center.x - this.curdeltaX < 0 &&
          this.dispW - (this.leftOffset * this.zoom + moveX + this.dispW * this.zoom) <
            this.originMarginTop
        ) {
          this.leftOffset -= moveX;
        } else {
        }
        if (event.center.y - this.curdeltaY > 0 && top < this.originImgTop) {
          this.topOffset += moveY;
        } else {
        }
        if (
          event.center.y - this.curdeltaY < 0 &&
          this.dispH - (this.topOffset * this.zoom + moveY + this.dispH * this.zoom) <
            this.originMarginTop
        ) {
          this.topOffset -= moveY;
        } else {
        }
        this.curdeltaX = event.center.x;
        this.curdeltaY = event.center.y;
      }
    },
    pinchEnd(event) {
      this.pinchVal.srcEventClientX = 0;
      this.pinchVal.srcEventClientY = 0;
      this.curZoom = this.zoom;
    },
    pinchIn(event) {
      if (event.scale < 0.94) {
        this.pinchVal.curScale = event.scale;
        this.pinchVal.deltaX = event.center.x - this.leftOffset;
        this.pinchVal.deltaY = event.center.y - this.originMarginTop;
        this.pinchVal.deltaY = this.pinchVal.deltaY < 0 ? 0 : this.pinchVal.deltaY;
        this.pinchVal.deltaX = this.pinchVal.deltaX < 0 ? 0 : this.pinchVal.deltaX;
        this.pinchVal.pinchMode = "pinchin";
        this.mouseWheel(this.pinchVal);
      }
    },
    onSwipeRight(event) {},
    pinchOut(event) {
      if (event.scale > 1.06) {
        this.pinchVal.curScale = event.scale;
        this.pinchVal.srcEventClientX = event.srcEvent.clientX;
        this.pinchVal.srcEventClientY = event.srcEvent.clientY;
        this.pinchVal.deltaX = event.center.x - this.leftOffset;
        this.pinchVal.deltaY = event.center.y - this.originMarginTop;
        this.pinchVal.deltaY =
          this.pinchVal.deltaY > this.dispH * 3 ? this.dispH * 3 : this.pinchVal.deltaY;
        this.pinchVal.deltaX =
          this.pinchVal.deltaX > this.dispW * 3 ? this.dispW * 3 : this.pinchVal.deltaX;
        this.pinchVal.pinchMode = "pinchout";
        this.mouseWheel(this.pinchVal);
      }
    },
    tap(ev) {},
    mouseWheel(ev) {
      let zoomPtX = 0;
      let zoomPtY = 0;
      if (!ev.offsetX) {
        zoomPtX = ev.deltaX / this.dispW;
        zoomPtY = ev.deltaY / this.dispH;
      } else {
        zoomPtX = ev.offsetX / this.dispW;
        zoomPtY = ev.offsetY / this.dispH;
      }
      let w1 = this.dispW;
      let h1 = this.dispH;
      if (!ev.offsetX && ev.pinchMode === "pinchout") {
        let z = this.curZoom;
        z += ev.curScale - 1;
        this.zoom = z > 3 ? 3 : z;
      } else if (!ev.offsetX && ev.pinchMode === "pinchin") {
        let z = this.curZoom;
        z += ev.curScale - 1;
        this.zoom = z < 1 ? 1 : z;
      } else if (ev.offsetX) {
        if (ev.deltaY > 0) {
          let z = this.zoom;
          z *= 0.95;
          if (z < 1.0) z = 1.0;
          this.zoom = z;
        } else if (ev.deltaY < 0) {
          let z = this.zoom;
          z *= 1.05;
          if (z > 3.0) z = 3.0;
          this.zoom = z;
        }
      }
      let loffset = this.leftOffset;
      let toffset = this.topOffset;
      loffset -= zoomPtX * (this.dispW - w1);
      toffset -= zoomPtY * (this.dispH - h1);
      if (loffset + this.originMarginLeft > this.originMarginLeft) {
        loffset = 0;
      } else if (
        loffset + this.originMarginLeft + this.dispW + this.originMarginLeft <
        this.width
      ) {
        loffset = this.width - this.dispW - this.originMarginLeft - this.originMarginLeft;
      }

      if (toffset + this.originMarginTop > this.originMarginTop) {
        toffset = 0;
      } else if (toffset + this.originMarginTop + this.dispH + this.originMarginTop < this.height) {
        toffset = this.height - this.dispH - this.originMarginTop - this.originMarginTop;
      }
      this.leftOffset = loffset;
      this.topOffset = toffset;
    },
    clickPaper() {
      paper._testid = this.canvasid;
      this.$emit("focus", 0, paper);
    },
    selectPaper(g) {
      this.$emit("paper", g, paper);
    }
  }
};
</script>
<style scoped>
.divbtn {
  width: 100px;
  height: 100px;
  border: 1px solid;
}
</style>



// WEBPACK FOOTER //
// src/common/components/ImageBox.vue